import {
    Baby,
    HousePlug,
    Laptop,
    LayoutGrid,
    Leaf,
    Shirt,
    ShoppingBasket,
    Smartphone,
    Sparkles,
    ToyBrick,
} from "lucide-react";
import {
    ReactNode,
} from "react";

export type NavbarSearchCategory = {
    id: string;
    label: string;
    keywords: string[];
    icon: ReactNode;
};

export const navbarSearchCategories:
    NavbarSearchCategory[] = [
        {
            id: "all",
            label: "All Categories",
            keywords: [
                "all",
                "everything",
                "products",
            ],
            icon: (
                <LayoutGrid
                    size={17}
                    strokeWidth={1.8}
                />
            ),
        },
        {
            id: "men-fashion",
            label: "Men Fashion",
            keywords: [
                "men",
                "fashion",
                "shirts",
                "clothing",
            ],
            icon: (
                <Shirt
                    size={17}
                    strokeWidth={1.8}
                />
            ),
        },
        {
            id: "women-fashion",
            label: "Women Fashion",
            keywords: [
                "women",
                "fashion",
                "clothing",
                "style",
            ],
            icon: (
                <Sparkles
                    size={17}
                    strokeWidth={1.8}
                />
            ),
        },
        {
            id: "fresh",
            label: "Fresh",
            keywords: [
                "fresh",
                "fruits",
                "vegetables",
                "produce",
            ],
            icon: (
                <Leaf
                    size={17}
                    strokeWidth={1.8}
                />
            ),
        },
        {
            id: "groceries",
            label: "Groceries",
            keywords: [
                "grocery",
                "groceries",
                "daily essentials",
            ],
            icon: (
                <ShoppingBasket
                    size={17}
                    strokeWidth={1.8}
                />
            ),
        },
        {
            id: "kids-toys",
            label: "Kids & Toys",
            keywords: [
                "kids",
                "toys",
                "baby",
                "children",
            ],
            icon: (
                <ToyBrick
                    size={17}
                    strokeWidth={1.8}
                />
            ),
        },
        {
            id: "baby-care",
            label: "Baby Care",
            keywords: [
                "baby",
                "care",
                "newborn",
            ],
            icon: (
                <Baby
                    size={17}
                    strokeWidth={1.8}
                />
            ),
        },
        {
            id: "beauty-personal",
            label: "Beauty & Personal",
            keywords: [
                "beauty",
                "personal",
                "care",
                "cosmetics",
            ],
            icon: (
                <Sparkles
                    size={17}
                    strokeWidth={1.8}
                />
            ),
        },
        {
            id: "mobiles",
            label: "Mobiles",
            keywords: [
                "mobile",
                "phone",
                "smartphone",
                "accessories",
            ],
            icon: (
                <Smartphone
                    size={17}
                    strokeWidth={1.8}
                />
            ),
        },
        {
            id: "electronics",
            label: "Electronics",
            keywords: [
                "electronics",
                "laptop",
                "gadgets",
                "tech",
            ],
            icon: (
                <Laptop
                    size={17}
                    strokeWidth={1.8}
                />
            ),
        },
        {
            id: "home-kitchen",
            label: "Home & Kitchen Appliances",
            keywords: [
                "home",
                "kitchen",
                "appliances",
                "furniture",
            ],
            icon: (
                <HousePlug
                    size={17}
                    strokeWidth={1.8}
                />
            ),
        },
    ];
